import {useContext} from 'react'

import {SiteEnvironmentContext} from 'context/SiteEnvironmentContext'

export function useSiteEnvironmentContext() {
  return useContext(SiteEnvironmentContext)
}
